import { Box, CircularProgress, Typography } from '@material-ui/core';
import { MemberCont, MemberItemCont, MemberName, MemberPic } from 'pages/Dashboard/Guardianship/Guardianship.styles';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { COLORS } from 'shared/constants/COLORS';
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog';
import { impersonate } from 'shared/redux/slicers/user.slicer';
import { useAppSelector } from 'shared/redux/store';
import { ls } from 'shared/utils/ls';

interface Props {
  showSelectProfile: boolean;
  close: () => void;
  pageName: string;
}

const GuardianshipModal: React.FC<Props> = ({ showSelectProfile, close, pageName }) => {
  const { user: userState, app: appState } = useAppSelector((state) => state);
  const { members } = appState.guardian;
  const [impersonating, setimpersonating] = useState('');
  const dispatch = useDispatch();
  const { setLS } = ls();

  const impersonateTalent = (id: string) => {
    const currentURL = window.location.href;
    setLS('prev_url', currentURL);
    if (id === userState?.user?.id) return close();
    setimpersonating(id);
    dispatch(impersonate(id));
  };

  return (
    <StyledDialog
      open={showSelectProfile}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: {
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        },
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          overflow: 'auto',
          paddingBottom: 3,
          justifyContent: 'center',
        }}
      >
        <Typography style={{ textAlign: 'center', padding: '10px', fontSize: 35 }}>
          Choose an account you {pageName}
        </Typography>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            overflowY: 'auto',
            padding: '16px 24px',
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, auto))',
          }}
        >
          <MemberCont
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, auto))',
              justifyContent: 'center',
            }}
          >
            {members.map((t: any) => (
              <MemberItemCont
                onClick={() => impersonateTalent(t.id)}
                key={t.id}
                style={{
                  flex: 1,
                  border: `solid 1px ${userState?.user?.id === t.id ? COLORS.PRIMARY : 'unset'}`,
                  height: '30vh',
                  width: '30vh',
                  maxHeight: '30vh',
                  minHeight: '30vh',
                  maxWidth: '30vh',
                  minWidth: '30vh',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
              >
                {impersonating === t.id ? (
                  <CircularProgress />
                ) : (
                  <React.Fragment>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <MemberPic
                        src={t.picture || '/assets/user.png'}
                        style={{
                          height: '20vh',
                          width: '20vh',
                          maxHeight: '20vh',
                          minHeight: '20vh',
                          maxWidth: '20vh',
                          minWidth: '20vh',
                        }}
                      />

                      <div
                        style={{
                          height: 42,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                        }}
                      >
                        <MemberName style={{ fontSize: 18, textAlign: 'center', margin: 0 }}>
                          {t.stage_name || t.first_name + ' ' + t.last_name}
                        </MemberName>
                        {t.user_types.includes('guardian') && (
                          <MemberName
                            style={{
                              fontSize: 17,
                              fontStyle: 'italic',
                              lineHeight: 1,
                              textAlign: 'center',
                              marginTop: -1,
                            }}
                          >
                            Guardian
                          </MemberName>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </MemberItemCont>
            ))}
          </MemberCont>
        </Box>
      </Box>
    </StyledDialog>
  );
};

export default GuardianshipModal;
